import { DateFields } from '@sigma-frontend-libs/commons'
import { isUUID } from '@sigmasms/commons'
import { TaskFrequency } from '@sigmasms/shared-types'

import { billingsSources, getLocaleDateString, getYesterday, proxy } from '@/utils'

import render from './render'

export default {
  name: 'TasksForm',

  mixins: [ proxy({ type: 'object' }) ],

  computed: {
    date() {
      let dateTitle
      if (this.proxy.startsAt) {
        dateTitle = getLocaleDateString(this.proxy.startsAt, this.locale)
      } else {
        dateTitle = this.getTranslate(`filter.date.titles.single.${DateFields.startsAt}`)
      }

      const result = {
        title: dateTitle,
        label: this.getTranslate(`filter.date.labels.single.${DateFields.startsAt}`),
        value: this.proxy.startsAt,
        min: getYesterday()
      }

      if (this.proxy.data.frequency !== TaskFrequency.once) {
        result.value = [ this.proxy.startsAt, this.proxy.data.endsAt ]
        result.label = this.getTranslate(`filter.date.labels.range.${DateFields.startsAt}`)
        result.min = this.proxy.startsAt || getYesterday()

        if (this.proxy.data.endsAt) {
          result.title = [
            getLocaleDateString(this.proxy.startsAt, this.locale),
            getLocaleDateString(this.proxy.data.endsAt, this.locale)
          ].join(' - ')
        }
      }

      return result
    },

    validation() {
      const amount = parseFloat(this.proxy.data.amount)

      if (!this.proxy.title) {
        return false
      }

      if (isNaN(amount) || amount <= 0) {
        return false
      }

      if (!Object.values(billingsSources).includes(this.proxy.data.source)) {
        return false
      }

      if (!isUUID(this.proxy.OwnerId)) {
        return false
      }

      if (!Object.values(TaskFrequency).includes(this.proxy.data.frequency)) {
        return false
      }

      return true
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    },

    proxy: {
      handler(value) {
        if (value.data.frequency === TaskFrequency.once) {
          value.data.endsAt = undefined
        }
      },
      deep: true
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
    this.proxy.data.amount = undefined
    this.proxy.data.source = billingsSources.subtract
  },

  render
}
